// removed by extract-text-webpack-plugin
module.exports = {"container":"mailThread-module-container-1d6a8b7897a520781192f1134f2966d3--","arrow-holder":"mailThread-module-arrow-holder-700ce9786372e07804a218e72c0acd34--","back":"mailThread-module-back-bfed789816b4474519396c3264ae058c--","subject":"mailThread-module-subject-801f4a81b26ab67440f3060a9cb5f0f9--","actorcard":"mailThread-module-actorcard-e4856d61daee659d1e856608cb7f8a20--"};


//////////////////
// WEBPACK FOOTER
// /src/components/mailThread/mailThread.module.scss
// module id = 1913
// module chunks = 0